<ng-template #preHeader>
    SECURE YOUR ACCOUNT
</ng-template>
<ng-template #description>
    We have sent you an email to {{email$ | async}} to verify
    your account. Please click on the verification link provided.
</ng-template>


<shared-auth-wrapper>
    <shared-auth-header preHeaderMarginTop="lg" marginBottom="xlg" [preHeader]="preHeader" [description]="description">
        Verify your email
    </shared-auth-header>
</shared-auth-wrapper>




<ng-template #left>
    <shared-link [disabled]="(isSendingToken$ | async) || (loading$ | async)" (onClick)="handleResendClick($event)"
        [emphasis]="false">Resend email
    </shared-link>
</ng-template>

<ng-template #right>
    <shared-forms-submit marginTop="none" width="normal" [loading]="(isSendingToken$ | async) || (loading$ | async)"
        (onClick)="handleEmailVerifyComplete($event)">
        {{(canOmmitEmailVerification$ | async) === true ? 'Done' : 'Verify'}}</shared-forms-submit>
</ng-template>

<!-- <shared-forms-actions [modal]="true" [left]="left" [right]="right"></shared-forms-actions> -->
<shared-forms-offset-wrapper [topOffset]="true" [modalOffset]="true" [left]="left" [right]="right">
</shared-forms-offset-wrapper>